var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 12.0003L4.6665 10.667M7.99984 12.0003L7.99984 10.0003M11.3332 12.0003V8.66699M1.6665 8.00033C1.6665 5.01477 1.6665 3.52199 2.594 2.59449C3.5215 1.66699 5.01428 1.66699 7.99984 1.66699C10.9854 1.66699 12.4782 1.66699 13.4057 2.59449C14.3332 3.52199 14.3332 5.01477 14.3332 8.00033C14.3332 10.9859 14.3332 12.4787 13.4057 13.4062C12.4782 14.3337 10.9854 14.3337 7.99984 14.3337C5.01428 14.3337 3.5215 14.3337 2.594 13.4062C1.6665 12.4787 1.6665 10.9859 1.6665 8.00033Z",
    stroke: "#242428",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99463 7.65783C5.43136 7.70571 8.68924 7.48888 10.5423 4.54787M9.32801 4.19256L10.5784 3.99132C10.7307 3.97191 10.9545 4.09223 11.0095 4.23564L11.3401 5.32794",
    stroke: "#242428",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/icon-report.9ddc691fe4e245d4c1fa0fc08f674352.svg";
export { ForwardRef as ReactComponent };